import React from "react"
import ReactDOM from "react-dom"
import "./index.scss"
import "./i18n"
import {ReactKeycloakProvider} from "@react-keycloak/web"
import App from "./App"
import {unregister} from "./serviceWorker"
import keycloak from "./keycloak"
import FullScreenCenteredLoading from "./core/components/FullScreenCenteredLoading"

ReactDOM.render(
    <React.StrictMode>
        <ReactKeycloakProvider
            authClient={keycloak}
            LoadingComponent={<FullScreenCenteredLoading />}
            initOptions={{onLoad: "login-required", enableLogging: true}}
            onEvent={(event, error) => {
                if (error) {
                    keycloak.login()
                }
            }}
        >
            <App />
        </ReactKeycloakProvider>
    </React.StrictMode>,
    document.getElementById("root")
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
unregister()
